module.exports = "table tbody tr td {\r\n  word-break: break-word;\r\n}\r\n"